import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { LoginRequest } from '../models/login-request.model';
import { LoginResponse } from '../models/login-response.model';
import { RegisterCompanyRequest } from 'src/app/core/models/register-company-request.model';
import { environment } from 'src/app/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // ✅ Use environment.apiUrl
  private api = `${environment.apiUrl}/api/auth`;

  constructor(private http: HttpClient) {}

  login(request: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.api}/login`, request);
  }

  registerCompany(request: RegisterCompanyRequest): Observable<any> {
    return this.http.post(`${this.api}/register-company`, request);
  }

  refresh(refreshToken: string) {
    return this.http.post(`${this.api}/refresh`, { refreshToken });
  }

  logout(refreshToken: string) {
    return this.http.post(`${this.api}/logout`, { refreshToken });
  }

  // ✅ Request OTP — sent to email
  forgotPassword(email: string): Observable<any> {
    return this.http.post(`${this.api}/forgot-password`, { email });
  }

  // ✅ Reset password with OTP
  resetPassword(email: string, otp: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.api}/reset-password`, {
      email,
      otp,
      newPassword
    });
  }
}